import * as React from "react";
const SvgFiRrAppleWhole = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-apple-whole_svg__a)">
      <path
        fill="#062147"
        d="M17.246 6.193a6.74 6.74 0 0 0 1.737-3.94A2 2 0 0 0 16.75.016 6.32 6.32 0 0 0 12.133 2.6 8.2 8.2 0 0 0 10.711.271a1 1 0 0 0-1.428 1.4 7.6 7.6 0 0 1 1.66 4.33H8.5A8.77 8.77 0 0 0 0 15c-.16 5.6 5.644 10.772 10.75 8.384a2.4 2.4 0 0 1 2.605.02A4.44 4.44 0 0 0 15.5 24c10.264-.284 11.566-15.418 1.746-17.807m-3.023-3.025A4.8 4.8 0 0 1 17 2a4.8 4.8 0 0 1-1.167 2.772 4.8 4.8 0 0 1-2.778 1.168 4.8 4.8 0 0 1 1.168-2.772M15.5 22a2.54 2.54 0 0 1-1.244-.38A4.6 4.6 0 0 0 12 21a4.5 4.5 0 0 0-2.137.593C6.005 23.261 1.9 19.141 2 15a6.77 6.77 0 0 1 6.5-7h7c8.6.321 8.6 13.682 0 14"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-apple-whole_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAppleWhole;
